import { useState } from "react";
import ProductListing from "../components/custom/search/ProductListing";
import CategoryFilter from "../components/custom/search/CategorySelector";
import ImportButton from "../components/custom/import/ImportButton";
import { PageContainer } from "../components/core/basic/PageContainer";
import { VStack } from "../../styled-system/jsx";
import { wrap } from "../../styled-system/patterns";
import { usePricingConfiguration } from "../modules/pricingv2/api/usePricingConfiguration";

/**
 * This view implements a product search page that supports basic querying
 * and filtering.
 */
const Search = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [importPOModel, setImportPOModel] = useState(false);

  const pricingConfigQuery = usePricingConfiguration();
  const hasInventoryModule = pricingConfigQuery.data?.use_incoming_inventory;

  return (
    <PageContainer className={wrap({ flexDirection: "row" })}>
      <VStack flex={"1"} alignItems={"stretch"} minWidth={"250px"} height="100%">
        <ImportButton showDownloadTemplate={true} />
        {hasInventoryModule && (
          <ImportButton
            defaultType={`product_po_history`}
            importModalOpen={importPOModel}
            setImportModalOpen={setImportPOModel}
            title={"Upload Incoming Inventory"}
          />
        )}

        <CategoryFilter currentCategory={selectedCategory} onCategorySelected={setSelectedCategory} />
      </VStack>
      <VStack flex={"3"} alignItems={"stretch"} minWidth={"400px"} height="100%">
        <ProductListing currentCategory={selectedCategory} key={selectedCategory} />
      </VStack>
    </PageContainer>
  );
};

export default Search;
